var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tooltip',{attrs:{"text":_vm.tooltipContent,"target":".tooltip-circle","aria-label":_vm.tooltipContent}},[_c('span',{staticClass:"tooltip-circle",attrs:{"tabindex":"0"}},[_c('i',{staticClass:"fa fa-question-circle"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }